import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './Hero.css';

const Hero: React.FC = () => {
  const { t } = useTranslation();
  const githubAvatar = 'https://avatars.githubusercontent.com/u/81973978?v=4';

  return (
    <section className="hero" id="home">
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.p 
            className="hero-greeting"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            {t('hero.greeting')}
          </motion.p>
          
          <motion.h1
            className="hero-name"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            Guilherme Mendes
          </motion.h1>
          
          <motion.h2
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            {t('hero.title')}
          </motion.h2>
          
          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
          >
            {t('hero.subtitle')}
          </motion.p>

          <motion.div
            className="hero-buttons"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <a href="#projects" className="btn btn-primary">
              {t('hero.cta')}
            </a>
            <a href="#contact" className="btn btn-outline">
              {t('hero.contact')}
            </a>
            <a
              href="https://portfolio-dados-nine.vercel.app/"
              className="btn btn-outline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('hero.dataPortfolio')}
            </a>
          </motion.div>

          <motion.div
            className="hero-social"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2 }}
          >
            <a href="https://github.com/Guiilhermendes" target="_blank" rel="noopener noreferrer">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/guilhermemnds/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="mailto:guilhermemendeds@gmail.com">
              <FaEnvelope />
            </a>
          </motion.div>
        </motion.div>

        <motion.div
          className="hero-image"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <div className="image-wrapper">
            <div className="floating-card card-1">
              <span>Node.js</span>
            </div>
            <div className="floating-card card-2">
              <span>React</span>
            </div>
            <div className="floating-card card-3">
              <span>AI</span>
            </div>
            <div className="hero-avatar">
              <img 
                src={`${process.env.PUBLIC_URL}/profile.png`}
                alt="Guilherme Mendes"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = githubAvatar;
                }}
              />
            </div>
          </div>
        </motion.div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default Hero;
